<template>
  <div>
		<splide
			v-if="splide_settings && options.length > 0"
			:options="splide_settings"
			@splide:mounted="onMounted"
			class="search-hero__carousel-slider"
			ref="splide"
		>
			<splide-slide v-for="(option,o) in options" :key="o">

				<template v-if="is_static">
					<a :href="`/search/${carousel_search_config.role}?q=${facetRef}%253D${encodeURIComponent(option.name)}`" :title="option.name">
						<esc-icon :name="option.name"></esc-icon>
						<p v-html="option.name"></p>
					</a>
				</template>
				<template v-else>
					<label :for="`${facetRef}_option_${o}`" :key="`option_${o}`" :class="{'active':option.selected}" :title="option.name">
						<input type="checkbox" :id="`${facetRef}_option_${o}`" v-model="option.selected" @change="changeValue"/>
						<esc-icon :name="option.name"></esc-icon>
						<p v-html="option.name"></p>
					</label>
				</template>

			</splide-slide>
		</splide>
	</div>
</template>

<script>
import algoliasearch from 'algoliasearch';

import SearchMixin from '@/main/pages/search/mixins/SearchMixin';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import EscIcon from '@/main/components/icons/EscIcon';

export default {
  mixins: [SearchMixin],

  components: {
    Splide,
    SplideSlide,
    EscIcon
  },

  props: {
    facetRef: {
      type: String
    },
		carousels_count: {
			type: Number,
			default: 2
		},
    type: {
      type: String,
			default: 'filter'
    },
		carousel_search_config: {
			type: Object
		}
  },

  data() {
    return {
			splide_settings: {
        type: 'slide', // slide/loop/fade
        autoplay: false,
        rewind: false,
        rewindSpeed: 1000,
        interval: 5000,
        width: '100%',
        gap: '1rem',
        arrows: true,
        pagination: false,
        perPage: (this.carousels_count == 2) ? 5 : 12,
        padding: {left: '1rem', right:'1rem'},
        breakpoints: {
          480: {
            perPage: 1,
          },
          640: {
            perPage: (this.carousels_count == 2) ? 1 : 3,
          },
          768: {
            perPage: (this.carousels_count == 2) ? 2 : 5,
          },
          1024: {
            perPage: (this.carousels_count == 2) ? 3 : 6,
          },
          1280: {
            perPage: (this.carousels_count == 2) ? 4 : 8,
          },
          1536: {
            perPage: (this.carousels_count == 2) ? 5 : 12,
          },
        }
      },
      options: []
    }
  },

	created() {
		if (this.is_static) {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			let index_name = (this.$config.test_env) ? this.carousel_search_config.algolia_test_index : this.carousel_search_config.algolia_index;
			this.index = this.client.initIndex(index_name);
			this.index.searchForFacetValues(this.facetRef, "").then(({ facetHits }) => {
				facetHits.forEach((option) => {
					var option_object = {'name':option.value, 'count':option.count, 'selected':false};
					this.options.push(option_object);
				});
			});
		} else {
    	this.emitter.on('update:facet-info',this.updateFacetInfo);
		}
	},

  beforeUnmount() {
    if (!this.is_static) {
			this.emitter.off('update:facet-info',this.updateFacetInfo);
		}
  },

  methods: {
    onMounted(splide) {
      //console.log('Splide mounted:', splide);
    },
    changeValue() {
      let new_list = this.selected_option_names;
      console.log("options changed", _.cloneDeep(this.options), new_list);
      this.search_params.global_facets[this.name] = new_list;
      this.emitter.emit('update:search');
    },
    doClear() {
      this.search_params.global_facets[this.name] = [];
      this.emitter.emit('update:search');
      this.$refs.splide.refresh();
    },
    updateFacetInfo(facet_info) {
			console.log("updateFacetInfo", facet_info);
      this.facet = facet_info.find((facet) => {
        return facet.ref == this.facetRef;
      });
      this.options = this.facet.options;
      this.$refs.splide.refresh();
      this.$forceUpdate();
    }
  },
  computed: {
    count() {
      return this.search_params.global_facets[this.name].length;
    },
    facet() {
      return this.facet_info.find((facet) => {
        return facet.ref == this.facetRef;
      });
    },
    name() {
      return this.facet.name;
    },
    label() {
      return this.facet.label;
    },
    selected_options() {
      return this.options.filter((option) => {
        return option.selected;
      });
    },
    selected_option_names() {
      return this.selected_options.map((option) => {
        return option.name;
      });
    },
		is_static(){
			return this.type == "search";
		}
  },
  watch: {
    facet_info: {
      deep: true,
      handler() {
        //console.log(`FacetCheckbox '${this.facetRef}' recognised change on facet_info`, this.facet_info);
        this.options = this.facet_info.find((facet) => {
          return facet.ref == this.facetRef;
        }).options;
        this.$forceUpdate();
      }
    },
    options: {
      deep: true,
      handler() {
        //console.log("options now:", this.facetRef, this.options);
      }
    }
  }
};
</script>
